<div class="oa-sheet add-item-sheet" id="create-item">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>{{ index < 0 ? 'Novo item' : 'Editar item' }}</h2>
        <button type="button" (click)="cancel()" class="oa-icon-btn" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body" #sheetBody>
        <form [formGroup]="form" (focusin)="onFormFocusIn($event)">
            <p class="required-hint">
                (<span class="mat-placeholder-required">*</span>) Campos obrigatórios
            </p>
            <div fxLayout="column" fxLayoutGap="10px">
                <!-- Imagem (quando configurada) ao lado do nome do item. No web, as sugestões abrem num painel
                     (autocomplete). Em telas compactas abrem em linha, abaixo do campo, sem cobrir os outros campos. -->
                <div class="name-row" [class.name-row--image]="fields.image">
                    <div *ngIf="fields.image" class="img-box" [class.is-empty]="!form.get('product_image')?.value" [class.is-loading]="uploading">
                        <button type="button" class="img-box__pick" (click)="imageInput.click()" [disabled]="uploading"
                            [attr.aria-label]="form.get('product_image')?.value ? 'Trocar imagem do item' : 'Adicionar imagem ao item'">
                            <img *ngIf="form.get('product_image')?.value" [src]="form.get('product_image')?.value" alt="">
                            <ng-container *ngIf="!form.get('product_image')?.value">
                                <mat-icon aria-hidden="true">add_photo_alternate</mat-icon>
                                <span>Adicionar imagem</span>
                            </ng-container>
                            <span *ngIf="form.get('product_image')?.value" class="img-box__overlay" aria-hidden="true">Trocar</span>
                            <mat-spinner *ngIf="uploading" diameter="28"></mat-spinner>
                        </button>
                        <input #imageInput type="file" accept="image/*" hidden (change)="uploadImage($event)">
                        <button *ngIf="form.get('product_image')?.value && !uploading" type="button" class="img-box__remove"
                            (click)="form.get('product_image')?.setValue(null)" aria-label="Remover imagem">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <mat-form-field appearance="outline" class="item-name-field">
                        <mat-label>Nome do item</mat-label>
                        <input autocomplete="off" [matAutocomplete]="auto" [matAutocompleteDisabled]="compact"
                            formControlName="item_name" matInput required maxlength="400" style="font-weight: 500;"
                            #itemName (focus)="onNameFocus()" (input)="openSuggestions()"
                            (keydown.escape)="closeSuggestions($event)"
                            [attr.role]="compact ? 'combobox' : null"
                            [attr.aria-expanded]="compact ? suggestionsOpen && hasSuggestions : null"
                            [attr.aria-controls]="compact ? 'item-suggestions' : null">


                        <mat-hint *ngIf="compact && !(suggestionsOpen && hasSuggestions)">Digite um item novo ou escolha um produto cadastrado</mat-hint>
                        <mat-hint align="end" *ngIf="(form.get('item_name')?.value || '').length > 350">{{ (form.get('item_name')?.value || '').length }}/400</mat-hint>

                        <mat-error *ngIf="form.get('item_name')?.hasError('maxlength')">
                            O nome do item não pode ter mais de 400 caracteres
                        </mat-error>
                        <mat-error *ngIf="form.get('item_name')?.hasError('required')">
                            Nome do item é obrigatório
                        </mat-error>

                        <mat-autocomplete #auto="matAutocomplete" class="oa-product-panel"
                            (opened)="onAutocompleteOpened(auto, itemNameControl)"
                            (optionSelected)="setProduct($event)">

                            <ng-container *ngIf="form != null">
                                <mat-option class="oa-product-option"
                                    *ngFor="let product of (controllersData.get(itemNameControl)?.results$ | async)" [value]="product">
                                    <span class="oa-product-option__thumb">
                                        <img *ngIf="product?.image" [src]="product.image" alt="" loading="lazy">
                                        <mat-icon *ngIf="!product?.image" aria-hidden="true">inventory_2</mat-icon>
                                    </span>
                                    <span class="oa-product-option__text">
                                        <b>{{ product?.title }}</b>
                                        <small *ngIf="productMeta(product)">{{ productMeta(product) }}</small>
                                        <small *ngIf="productStock(product) as stock" class="oa-product-option__stock oa-product-option__stock--{{ stock.tone }}">{{ stock.label }}</small>
                                    </span>
                                    <span class="oa-product-option__price">{{ formatCurrency(product?.valor) }}</span>
                                </mat-option>
                            </ng-container>

                            <!-- ORCA-1975: sem produtos que combinem não há opção nenhuma e o painel não abre -->
                            <mat-option *ngIf="form && (controllersData.get(itemNameControl)?.isLoadingMore$ | async)"
                                disabled class="oa-product-panel__status">
                                Carregando...
                            </mat-option>
                            <mat-option class="oa-product-option oa-product-option--new"
                                *ngIf="hasSuggestions && form.get('item_name')?.value && !itemProductIdControl.value" [value]="NEW_ITEM_OPTION">
                                <mat-icon aria-hidden="true">add</mat-icon>
                                <span>Adicionar “{{ lastTypedName }}” como item novo</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- Sugestões em linha (telas compactas): mesmo padrão da busca no web; só com produtos que
                     combinem com o nome (ORCA-1975: sem isso a lista abria vazia e empurrava os campos) -->
                <div *ngIf="compact && suggestionsOpen && hasSuggestions" class="item-suggestions">
                    <div class="item-suggestions__header">
                        <span>Do seu cadastro</span>
                        <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" (click)="closeSuggestions()">
                            Fechar
                        </button>
                    </div>
                    <ul id="item-suggestions" class="oa-option-list item-suggestions__list" role="listbox"
                        aria-label="Produtos e serviços" #suggestionsList>
                        <li *ngFor="let product of (controllersData.get(itemNameControl)?.results$ | async)" role="none">
                            <button type="button" class="oa-option item-suggestion" role="option"
                                [attr.aria-selected]="itemProductIdControl.value === product.id"
                                (mousedown)="$event.preventDefault()" (click)="selectProduct(product)">
                                <span class="oa-product-option__thumb">
                                    <img *ngIf="product?.image" [src]="product.image" alt="" loading="lazy">
                                    <mat-icon *ngIf="!product?.image" aria-hidden="true">inventory_2</mat-icon>
                                </span>
                                <span class="oa-option__text">
                                    <span class="oa-option__title">{{ product?.title }}</span>
                                    <span class="oa-option__meta" *ngIf="productMeta(product)">{{ productMeta(product) }}</span>
                                    <span *ngIf="productStock(product) as stock" class="oa-option__meta oa-product-option__stock oa-product-option__stock--{{ stock.tone }}">{{ stock.label }}</span>
                                </span>
                                <span class="oa-option__aside" *ngIf="product?.valor != null">{{ formatCurrency(product.valor) }}</span>
                            </button>
                        </li>
                    </ul>
                    <div class="oa-option-empty" *ngIf="controllersData.get(itemNameControl)?.isLoadingMore$ | async">
                        Carregando...
                    </div>
                    <button *ngIf="form.get('item_name')?.value && !itemProductIdControl.value" type="button"
                        class="item-suggestions__new" (mousedown)="$event.preventDefault()" (click)="keepTypedName()">
                        <mat-icon aria-hidden="true">add</mat-icon>
                        Adicionar “{{ form.get('item_name')?.value }}” como item novo
                    </button>
                </div>

                <p *ngIf="fromCatalog" class="catalog-note">
                    <mat-icon aria-hidden="true">inventory_2</mat-icon>
                    Preenchido com o cadastro do produto. Mudanças aqui valem só para este orçamento.
                </p>

                <!-- ORCA-1945: unidade, quantidade, valor unitário e total logo abaixo do nome -->
                <div class="values-grid">
                    <mat-form-field appearance="outline">
                        <mat-label>Unidade</mat-label>
                        <mat-select formControlName="item_unit_id">
                            <mat-option *ngFor="let unit of units" [value]="unit.id">
                                <span>{{ unit?.name }}{{ unit?.abbr ? ' (' + unit.abbr + ')' : '' }}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Quantidade</mat-label>
                        <input autocomplete="off" class="hide-number-spinner" clearFieldIf formControlName="item_quantity"
                            matInput type="number" inputmode="decimal" [readonly]="isValueHidden">
                        <span matSuffix class="input-suffix" *ngIf="getUnitSuffixById(form?.get('item_unit_id').value)">
                            &nbsp;{{ getUnitSuffixById(form?.get('item_unit_id').value) }}
                        </span>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Valor unitário</mat-label>
                        <input [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }"
                            inputmode="numeric" autocomplete="off" class="hide-number-spinner" currencyMask appCaretAtEnd
                            formControlName="item_per_unit" matInput [readonly]="isValueHidden">
                    </mat-form-field>

                    <div class="total" aria-live="polite">
                        <span>Total</span>
                        <strong>{{ getTotal() }}</strong>
                    </div>
                </div>

                <div *ngIf="isValueHidden" class="hidden-value-note">
                    <mat-icon>visibility_off</mat-icon>
                    <span>Valor oculto neste item. Altere pelo menu do item no orçamento.</span>
                </div>

                <!-- Descrição na largura inteira (pode ser longa) e categoria, conforme "Detalhes dos itens" -->
                <mat-form-field *ngIf="fields.description" appearance="outline" class="desc-field">
                    <mat-label>Descrição</mat-label>
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10" maxlength="5000"
                        placeholder="Descreva o item (opcional)" [value]="descriptionText"
                        (input)="onDescriptionInput($event)"></textarea>
                </mat-form-field>

                <div *ngIf="fields.category || fields.code" class="meta-grid" [class.meta-grid--two]="fields.category && fields.code">
                    <mat-form-field *ngIf="fields.category" appearance="outline">
                        <mat-label>Categoria</mat-label>
                        <input matInput formControlName="product_category_name" maxlength="120" autocomplete="off"
                            placeholder="Escolha ou crie uma categoria" [matAutocomplete]="catAuto">
                        <mat-icon matSuffix class="secondary-text" aria-hidden="true">expand_more</mat-icon>
                        <mat-autocomplete #catAuto="matAutocomplete" class="oa-category-panel">
                            <mat-option *ngFor="let c of categoryOptions" [value]="c">{{ c }}</mat-option>
                        </mat-autocomplete>
                        <mat-hint *ngIf="isNewCategory">Nova categoria</mat-hint>
                    </mat-form-field>
                    <mat-form-field *ngIf="fields.code" appearance="outline">
                        <mat-label>Código</mat-label>
                        <input matInput formControlName="product_code" maxlength="60" autocomplete="off">
                    </mat-form-field>
                </div>

                <!-- Salvar item em produtos (item novo, fora do cadastro) -->
                <mat-checkbox *ngIf="itemProductIdControl.value == null" class="save-item-check"
                    [checked]="!!form.get('should_save')?.value"
                    [disabled]="!canSaveProduct && !form.get('should_save')?.value"
                    (change)="form.get('should_save')?.setValue($event.checked); showFeedBackItemSaveMessage($event.checked)">
                    Salvar também em Produtos e Serviços{{ fields.image || fields.description ? ' (com imagem, descrição e categoria)' : '' }}
                    <small>{{ !canSaveProduct && !form.get('should_save')?.value ? 'Limite de cadastro de produtos e serviços atingido.' : 'Opcional. Sem marcar, o item fica só neste orçamento.' }}</small>
                </mat-checkbox>

                <p class="details-hint">
                    {{ detailsOn
                        ? 'Imagem, descrição e código aparecem conforme “Detalhes dos itens”.'
                        : '“Mostrar detalhes dos itens” está desligado: aparecem no orçamento só nome, quantidade e valores.' }}
                </p>
            </div>
        </form>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" (click)="cancel()" class="oa-btn oa-btn--ghost">
            Cancelar
        </button>
        <button type="button" [disabled]="form.invalid || uploading" (click)="saveItem()" class="oa-btn oa-btn--primary">
            <span class="oa-btn__label">{{ index < 0 ? "Adicionar item" : "Salvar item" }}</span>
        </button>
    </footer>
</div>
